const RANKING = [
  {
    rank: 1,
    title: '星际穿越2：时空裂隙',
    info: '科幻 / 诺兰执导',
    hot: '9.7',
    viewers: '128万次播放',
    icon: 'ri-medal-fill',
    color: 'text-amber-500',
  },
  {
    rank: 2,
    title: '哪吒之魔童闹海',
    info: '动画 / 国产现象级',
    hot: '9.5',
    viewers: '216万次播放',
    icon: 'ri-medal-fill',
    color: 'text-gray-400',
  },
  {
    rank: 3,
    title: '春风沉醉的夜晚',
    info: '文艺 / 戛纳获奖',
    hot: '9.3',
    viewers: '87万次播放',
    icon: 'ri-medal-fill',
    color: 'text-amber-700',
  },
  {
    rank: 4,
    title: '流浪地球4：新家园',
    info: '科幻 / 国产硬核',
    hot: '9.2',
    viewers: '195万次播放',
    icon: 'ri-medal-line',
    color: 'text-foreground-400',
  },
  {
    rank: 5,
    title: '蝙蝠侠：暗夜骑士归来',
    info: '动作 / DC超级英雄',
    hot: '9.1',
    viewers: '164万次播放',
    icon: 'ri-medal-line',
    color: 'text-foreground-400',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            根据实时播放量、用户评分和讨论热度综合排名的电影榜
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-2 md:space-y-3">
          {RANKING.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-5 p-3 md:p-4 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer border border-secondary-100/60"
            >
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center flex-shrink-0">
                {i < 3 ? (
                  <i className={`${item.icon} ${item.color} text-xl md:text-2xl`}></i>
                ) : (
                  <span className="text-sm md:text-base font-medium text-foreground-500">
                    {item.rank}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.info}</p>
              </div>

              <div className="text-right flex-shrink-0">
                <div className="text-sm md:text-base font-heading text-accent-600">
                  {item.hot}
                </div>
                <div className="text-xs text-foreground-400">{item.viewers}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}